function searchMBA() {
    const findBtnObj = {
        base: "mba",
        subject: "",
        country: "",
        type: "",
    };

    document
        .querySelector('#nationality[data-plugin="choises"]')
        .addEventListener("addItem", function (e) {
            findBtnObj.subject = e.detail.value.trim() || "";
        });

    document
        .querySelector('#mba_country[data-plugin="choises"]')
        .addEventListener("addItem", function (e) {
            findBtnObj.country = e.detail.value.trim() || "";
        });

    document
        .querySelector('#program_type[data-plugin="choises"]')
        .addEventListener("addItem", function (e) {
            findBtnObj.type = e.detail.value.trim() || "";
        });

    document
        .querySelector('[data-btn="find-mba"]')
        .addEventListener("click", function (e) {
            e.preventDefault();

            const mbaURL =
                "/" +
                [findBtnObj.base, findBtnObj.subject, findBtnObj.country, findBtnObj.type]
                    .filter(Boolean)
                    .join("/");
            location.href = mbaURL;
        });
}
export { searchMBA };